import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledClaimStatusTitle = styled('div')(
  ({ theme }) => css`
    align-items: center;
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    justify-content: space-between;
  `
);

export const StyledHelpCenterTipContainer = styled('div')(
  ({ theme }) => css`
    background-color: ${theme.palette.background.info};
    column-gap: ${theme.spacing('SMALL')};
    display: flex;
    padding: ${theme.spacing('LARGE')};
  `
);

export const StyledRequestForInformationDocumentDownloadContainer = styled('div')(
  ({ theme }) => css`
    background: ${theme.palette.background.viewport};
    padding: ${theme.spacing('LARGE')};
  `
);

export const StyledSeparator = styled('div')(
  ({ theme }) => css`
    background-color: ${theme.palette.main.product_blue};
    border: none;
    height: 1px;
    margin: 0;
    width: 100%;
  `
);

export const StyledUserClaimComments = styled('div')(
  ({ theme }) => css`
    background-color: ${theme.palette.main.professional_light_blue};
    color: ${theme.palette.common.white};
    border-radius: 2px;
    padding: ${theme.spacing('LARGE')};
  `
);
